const styles = {
  chipsContainer: (breakDiscoverScreen: boolean) => ({
    pt: breakDiscoverScreen ? 0 : { xs: 1 },
    pb: breakDiscoverScreen ? 2 : 1,
    px: breakDiscoverScreen ? 2 : 0,
    mb: { xs: 2, md: 0 },
    background: "white",
    display: "flex",
    overflowX: "auto",
    overflowY: "hidden",
  }),
  selectedChip: {
    borderRadius: 2,
  },
};

export default styles;
